import { render } from "./CheckerRegisterView.vue?vue&type=template&id=6f573a46"
import script from "./CheckerRegisterView.vue?vue&type=script&lang=js"
export * from "./CheckerRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__